module.exports = __webpack_public_path__ + "images/emoji/monkey_face.8eb82fe5b1548341d893.png";